import axios from 'axios';
import { CUSTOMER_SEARCH_REQUEST, CUSTOMER_SEARCH_SUCCESS, CUSTOMER_SEARCH_FAIL, GET_CUSTOMERS_REQUEST, GET_CUSTOMERS_SUCCESS, GET_CUSTOMERS_FAIL, CREATE_CUSTOMER_REQUEST, CREATE_CUSTOMER_SUCCESS, CREATE_CUSTOMER_FAIL, GET_CUSTOMER_REQUEST, GET_CUSTOMER_SUCCESS, GET_CUSTOMER_FAIL } from '../constants/customerConstants';

export const searchCustomer = (firstname, lastname, nic, contact) => async (dispatch, getState) => {

    try {

        const { userAccess } = getState();

        dispatch({
            type: CUSTOMER_SEARCH_REQUEST,
        });

        const config = {
            headers: {
                Authorization: `Bearer ${userAccess.userInfo.token}`
            },
        };

        const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URI}/customers/search/${firstname}/${lastname}/${nic}/${contact}`, config);

        dispatch({
            type: CUSTOMER_SEARCH_SUCCESS,
            payload: data
        });
    } catch (error) {
        dispatch({
            type: CUSTOMER_SEARCH_FAIL,
            payload: 'An error Occurred'
        });
    }
};


export const getCustomers = () => async (dispatch, getState) => {

    try {

        const { userAccess } = getState();

        dispatch({
            type: GET_CUSTOMERS_REQUEST,
        });

        const config = {
            headers: {
                Authorization: `Bearer ${userAccess.userInfo.token}`
            },
        };

        const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URI}/customers`, config);

        dispatch({
            type: GET_CUSTOMERS_SUCCESS,
            payload: data
        });
    } catch (error) {
        dispatch({
            type: GET_CUSTOMERS_FAIL,
            payload: 'An error Occurred'
        });
    }
};


export const getCustomer = (id) => async (dispatch, getState) => {

    try {

        const { userAccess } = getState();

        dispatch({
            type: GET_CUSTOMER_REQUEST,
        });

        const config = {
            headers: {
                Authorization: `Bearer ${userAccess.userInfo.token}`
            },
        };

        const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URI}/customers/${id}`, config);

        dispatch({
            type: GET_CUSTOMER_SUCCESS,
            payload: data
        });
    } catch (error) {
        dispatch({
            type: GET_CUSTOMER_FAIL,
            payload: 'An error Occurred'
        });
    }
};


export const createNewCustomer = (firstname, lastname, contact, email, dob, houseNo, streetAddress, streetAddress2, city, customerType, nic) => async (dispatch, getState) => {

    try {

        const { userAccess } = getState();

        dispatch({
            type: CREATE_CUSTOMER_REQUEST,
        });

        const config = {
            headers: {
                Authorization: `Bearer ${userAccess.userInfo.token}`,
                'Content-Type': 'application/json'
            },
        };

        const formData = {
            firstname,
            lastname,
            contact,
            email,
            dob,
            houseNo,
            streetAddress,
            streetAddress2,
            city,
            customerType,
            nic
        }

        const { data } = await axios.post(`${process.env.REACT_APP_BACKEND_URI}/customers`, formData, config);

        dispatch({
            type: CREATE_CUSTOMER_SUCCESS,
            payload: data
        });

    } catch (error) {
        console.log(error)
        dispatch({
            type: CREATE_CUSTOMER_FAIL,
            payload: 'An error Occurred'
        });
    }
};